import { Box, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React, { useDebugValue, useEffect, useState } from "react";
import { AyudantiaInvestigacionData, PlanificacionAyudantia, VoidPlanificacionAyudantia } from "../../interfaces/AYUDANTIAS/Ayudantia";
import { useAppSelector } from "../../redux/hooks";
import AyudantiaService from "../../services/AyudantiaService";
import { useIsAuthenticated } from "@azure/msal-react";
import { PantallaCargaPage } from "../../pages/Modulos/PantallaCargaPage";
import { TableSolicitudAyudVic } from "./TableSolicituAyudVic";
import { PlanificacionAyudantias } from "./PlanificacionAyudantias";


const ayudantiaService = new AyudantiaService();
export const SolicitudesAyudantiasVicerrector: React.FC = () => {
    
    const [solicitudesPendVic, setSolicitudesPendVic] = useState<Array<AyudantiaInvestigacionData>>([]);
    const [solicitudesApVic, setSolicitudesApVic] = useState<Array<AyudantiaInvestigacionData>>([]);
    const [solicitudesRecVic, setSolicitudesRecVic] = useState<Array<AyudantiaInvestigacionData>>([]);

    const[readySolPendientes, setReadySolPendientes] = useState<boolean>(false);
    const[readySolAprobadas, setReadySolAprobadas] = useState<boolean>(false);
    const[readySolRechazadas, setReadySolRechazadas] = useState<boolean>(false);
    const[resumenHoras, setResumenHoras] = useState<PlanificacionAyudantia>(VoidPlanificacionAyudantia());
    const[readyResumen, setReadyResumen] = useState<boolean>(false);

    const { userData } = useAppSelector((state) => state.authReducer);
    const token = useAppSelector((state) => state.authReducer.token);

    const isAuthenticated = useIsAuthenticated();

    const handleReadyAprobadas = () =>{
        setReadySolAprobadas(false);
    }
    
    const handleReadyPendientes = () =>{
        setReadySolPendientes(false);
    }

    const handleReadyRechazadas = () => {
        setReadySolRechazadas(false);
    }

    let tipoPersonaVicerrector = userData.unidadesVicerrector.tipoPersona ==='V' ? 'V':'';

    const GetSolicitudesVicerrectorPendientes = async (tipoPersona : string) => {
        try {
            await ayudantiaService.GetSolicitudesAyudantiasPendientesByTipoPersona(token, tipoPersona)
            .then((data) => {

                if (data.status.isSuccessfully) {
                    setSolicitudesPendVic(data.listData);
                    setReadySolPendientes(true);
                } else {
                    setSolicitudesPendVic([]);
                    setReadySolPendientes(true);
                }
            })
            .catch((error) => console.error(error));
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const GetSolicitudesVicerrectorAprobadas = async (tipoPersona : string) => {
        try {
            await ayudantiaService.GetSolicitudesAyudantiasAprobadasByTipoPersona(token, tipoPersona)
            .then((data) => {

                if (data.status.isSuccessfully) {
                    setSolicitudesApVic(data.listData);
                    setReadySolAprobadas(true);
                } else {
                    setReadySolAprobadas(true);
                    setSolicitudesApVic([])
                }
            })
            .catch((error) => console.error(error));
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const GetSolicitudesVicerrectorRechazadas = async (tipoPersona : string) => {
        try {
            await ayudantiaService.GetSolicitudesAyudantiasRechazadasByTipoPersona(token, tipoPersona)
            .then((data) => {

                if (data.status.isSuccessfully) {
                    setSolicitudesRecVic(data.listData);
                    setReadySolRechazadas(true);
                } else {
                    setReadySolRechazadas(true);
                    setSolicitudesRecVic([]);
                }
            })
            .catch((error) => console.error(error));
        } catch (error) {
            console.error('Error:', error);
        }
    };

    

    useEffect(()=>{
       GetSolicitudesVicerrectorPendientes(tipoPersonaVicerrector);
    },[token,isAuthenticated ,readySolPendientes])

    useEffect(()=>{
        GetSolicitudesVicerrectorAprobadas(tipoPersonaVicerrector);
    },[token, isAuthenticated,readySolAprobadas])

    useEffect(()=>{
        GetSolicitudesVicerrectorRechazadas(tipoPersonaVicerrector);
    },[token,isAuthenticated ,readySolRechazadas])

    useEffect(()=>{
        if (isAuthenticated ) {
          GetHorasResumenPlanificacion();
        }
      },[token,isAuthenticated, readyResumen, readySolAprobadas, readySolPendientes])

    const GetHorasResumenPlanificacion = async()=>{
        try{
        await ayudantiaService.GetResumenAsignacionAyudantias(token)
        .then((data)=>{
            if(data.status.isSuccessfully){
            setResumenHoras(data.data);
            setReadyResumen(true);
            }
            
            else{
            setResumenHoras(VoidPlanificacionAyudantia())
            }
            
        })
    
        }catch(error){
        console.error('Error',error)
        }
    }


    return (
        <Container maxWidth="lg" sx={{ padding: "20px" }}>
            <Typography
                variant="h4"
                align="center"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }}
            >
                SOLICITUDES DE AYUDANTÍAS
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
                <Box
                sx={{
                    height: 4,
                    width: "100px",
                    bgcolor: "primary.main",
                    borderRadius: "2px",
                }}
                />
            </Box>
            {
                <Container>
                    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <PlanificacionAyudantias ready={readyResumen} planificacion={resumenHoras} />
                    </Box>



                    <Paper  elevation={3} sx={{ padding: 2, marginBottom: 3 }}>
                        <Typography variant="h5" sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }} gutterBottom>
                        Solicitudes pendientes
                        </Typography>
                        {
                        readySolPendientes ?
                        <TableSolicitudAyudVic solicitudes={solicitudesPendVic} rowsPerPage={[5,10,25,100]} 
                        onActionPendientes={handleReadyPendientes} onActionAprobadas={handleReadyAprobadas} 
                        onActionRechazadas={handleReadyRechazadas} showAcciones={true} tipoPersona="V"/>
                       
                        :
                        <PantallaCargaPage />
                        }
                    </Paper>

                    <Paper  elevation={3} sx={{ padding: 2, marginBottom: 3 }}>
                        <Typography variant="h5" sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }} gutterBottom>
                            Solicitudes aprobadas
                        </Typography>
                        {
                            readySolAprobadas ?
                            <TableSolicitudAyudVic rowsPerPage={[5, 10, 25, 100]} tipoPersona="V"
                            solicitudes={ solicitudesApVic } onActionAprobadas={handleReadyAprobadas} 
                            onActionPendientes={handleReadyPendientes} showAcciones={false}
                            />
                            :
                            <PantallaCargaPage />
            
                        }
                    </Paper>

                    <Paper  elevation={3} sx={{ padding: 2, marginBottom: 3 }}>
                        <Typography variant="h5" sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }} gutterBottom>
                            Solicitudes Rechazadas
                        </Typography>
                        {
                            readySolRechazadas ?
                            <TableSolicitudAyudVic rowsPerPage={[5, 10, 25, 100]} tipoPersona="V"
                            solicitudes={ solicitudesRecVic } onActionRechazadas={handleReadyRechazadas} 
                            onActionPendientes={handleReadyPendientes} showAcciones={false}
                            />
                            :
                            <PantallaCargaPage />
            
                        }
                    </Paper>
                </Container>
            }
        </Container>
    )
   

}
